import React, { Component } from "react";
import { Switch } from "react-router";
import { Layout } from "./Layout";
import { RouteWithLayout } from "./RouteWithLayout";
import { TicketRefundPage } from "../pages/ticket-refund/TicketRefundPage";

export class TicketRefundSwitch extends Component {
  render() {
    return (
      <Switch>
        <RouteWithLayout layout={Layout} exact path="/" component={TicketRefundPage} />
      </Switch>
    );
  }
}
